/* eslint-disable @angular-eslint/directive-selector */
import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[rentalRestrictPhone]',
  standalone: true
})
export class RestrictPhoneDirective {

  constructor() { }
  @HostListener('input', ['$event'])
  onInput(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    if (input.value.length > 15) {
      event.preventDefault();
      input.value = input.value.slice(0, 15);
    }
  }
}
